import { GameApiBase, IAnimationControllerConfiguration, Inject, SoundType } from "@denishussar/html5-game-engine";
import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";
import { SoundConstants, SoundLevels } from "../../Constants/SoundConstants";
import { GameModel } from "../../Models/GameModel";

export enum MuteStateEnum {
    released,
    hover,
    pressed
}

export class UIMuteController extends ButtonController {
    $model: GameModel;
    private onClick: ()=>void;
    private state:number = 0;
    constructor(
        @Inject _options: IButtonControllerOptions,
        @Inject _arenaApi: GameApiBase,
    ) {
        super(_options, _arenaApi);
        this.onClick = _options.onClick;
    }

    getConfiguration() {
        return <IAnimationControllerConfiguration>{
            sounds: [
                { 
                    id: SoundConstants.BUTTON_CLICK,
                    type: SoundType.SFX
                },
            ],
            onPointerDown: () => {
                this.state = MuteStateEnum.pressed;
                this.onClick();
                // this.animate(MuteStateEnum.pressed);
                this.soundManager.playSound(SoundConstants.BUTTON_CLICK, 0, SoundLevels.UI_ACTION);   
            },
            onPointerUp: () => {
                this.state = MuteStateEnum.released;
                this.animate(MuteStateEnum.released);
                
            },
            onPointerOut: () => {
                this.state = MuteStateEnum.released;
                this.animate(MuteStateEnum.released);
            },
            onPointerOver: () => {
                this.state = MuteStateEnum.hover;
                this.animate(MuteStateEnum.hover);
            },
            modelWatch: {
                muteState: (mute:boolean) => {
                    console.log("changed mute");
                this.animate(this.state);  
                }, 
            }

        }
    }

    private animate(state: number) {
        switch (state) {
            case MuteStateEnum.released:
                if (this.$model.muteState)
                    this.gotoAndStop("active_mute");
                else
                    this.gotoAndStop("active");
                break;
            case MuteStateEnum.hover:
                if (this.$model.muteState)
                    this.gotoAndStop("hover_mute");
                else
                    this.gotoAndStop("hover");
                break;
            case MuteStateEnum.pressed:
                if (this.$model.muteState)
                    this.gotoAndStop("press_mute");
                else
                    this.gotoAndStop("press");
                break;
        }
    }


}